angular
  .module('contrast.factory.contrast.license', [])
  .factory('ContrastLicenseFactory', function ($http) {
    return {
      isLicenseActive: function () {
        //do not require orgUuid
        return $http.head('/Contrast/api/ng/contrast/license/active')
      }
    }
  })
